<script setup lang="ts">
/**
 * character poses components
 * @Victor/Ruolin
 * 1. single character pose, previous message doesn't have any pose
 * 2. double characters, put new character on the right side, flip the right side one
 * 3. double character
 */
import { computed } from 'vue'
import CharacterPoseImg from './CharacterPoseImg.vue'
import type { SpritePosition } from '@/types'

interface Props {
  positions: (SpritePosition | undefined)[]
  currentIndex: number
}

const props = defineProps<Props>()
const currentPosition = computed(() => {
  return props.positions[props.currentIndex]
})
const left = computed(() => {
  return currentPosition.value?.left
})
const middle = computed(() => {
  return currentPosition.value?.middle
})
const right = computed(() => {
  return currentPosition.value?.right
})
</script>

<template>
  <!-- Left Character Pose -->
  <character-pose-img
    v-if="left?.name"
    :is-active="left?.active || false"
    :url="left?.url"
    :class-name="['-translate-x-20']"
  />
  <!-- Middle Character Pose -->
  <character-pose-img
    v-if="middle?.name"
    :is-active="middle?.active || false"
    :url="middle?.url"
  />
  <!-- Right Character Pose -->
  <character-pose-img
    v-if="right?.name"
    :is-active="right?.active || false"
    :url="right?.url"
    :class-name="['translate-x-20', '-scale-x-100']"
  />
</template>

<style>
.responsive-image {
  object-fit: cover;
  width: auto; /* Ensures the width is automatically adjusted */
}

.tall-height {
  height: 90%;
}

.standard-height {
  height: 80%;
}

.short-height {
  height: 70%;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-in {
  animation: fadeIn ease 1s;
  -webkit-animation: fadeIn ease 1s;
  -moz-animation: fadeIn ease 1s;
  -o-animation: fadeIn ease 1s;
  -ms-animation: fadeIn ease 1s;
}

.active-image {
  z-index: 11; /* Higher z-index for active image */
}

.inactive-image {
  z-index: 10; /* Lower z-index for inactive image */
  opacity: 0.5; /* Assuming you want to keep the inactive images semi-transparent */
}
</style>
